import React from "react";
import { BrowserRouter } from "react-router-dom";
import MainMenu from "../MainMenu";

const Routing = () => {
  return (
    <BrowserRouter>
      <MainMenu />
    </BrowserRouter>
  );
};

export default Routing;
